<template>
  <div class="house-board-button">
    <div
      v-show="showNotificationAlert"
      class="house-board-button__alert"
    />
    <ShIcon
      :name="iconColor"
      role="button"
      aria-label="house-board"
      tabindex="0"
      @click="openHouseBoard"
    />
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { ShIcon } from '@sohohouse/design-system'

  import UIMixin from '~/mixins/ui'

  const {
    mapGetters: mapNotificationGetters,
    mapActions: mapNotificationActions
  } = createNamespacedHelpers('notifications')

  const {
    mapGetters: mapEnvGetters
  } = createNamespacedHelpers('ui/environment')


  export const POLL_INTERVAL = 30000

  const ShLogoVariants = {
    Light: 'shLogo',
    Dark: 'shLogoInvert'
  }

  export default {
    components: {
      ShIcon
    },

    mixins: [
      UIMixin
    ],

    data () {
      return {
        pollingInterval: 0
      }
    },

    computed: {
      ...mapNotificationGetters(['showNotificationAlert']),
      ...mapEnvGetters(['isDarkTheme']),

      iconColor () {
        return this.isDarkTheme ? ShLogoVariants.Dark : ShLogoVariants.Light
      }
    },

    mounted () {
      const isNotificationsEnabled = this.$env.DISABLE_NOTIFICATIONS === 'false'

      if (isNotificationsEnabled) {
        this.pollingInterval = setInterval(() => this.fetchNotifications(), POLL_INTERVAL)
      }
    },

    beforeDestroy () {
      clearInterval(this.pollingInterval)
    },

    methods: {
      ...mapNotificationActions(['fetchNotifications']),

      openHouseBoard () {
        this.$ui.modal.open('house-board')
      }
    }
  }
</script>

<style lang="scss" scoped>

.house-board-button {
  margin-right: $space-050;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-items: center;

  &__alert {
    width: $space-020;
    height: $space-020;
    border-radius: 50%;
    background-color: $color-alert;
    position: absolute;
    top: -$space-020;
    right: -$space-020;
  }
}
</style>
